var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('mPageTitle',{attrs:{"title":_vm.$t(_vm.page.title),"description":_vm.$t(_vm.page.description),"image":require('@/assets/images/webp/about.webp')}}),_c('mAbout'),_c('mDelivery')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }